import React from 'react';
import {
  BrowserRouter as Router,
  Link
} from "react-router-dom";

class Home extends React.Component {
    render() {
      return (
        <section className="select vcenter">
          <Link  to={"/omsg-report/general"} className="item">
              <div className="logo vcenter">
                  <img src={require('../../../assets/icons/icon-home-list.png')} />
              </div>
              <div className="text vcenter">
                  <span>
                  Genel Durum
                  </span>
              </div>
          </Link>
          <Link  to={"/omsg-report/daily"} className="item">
              <div className="logo vcenter">
                <img src={require('../../../assets/icons/icon-home-message.png')} />
              </div>
              <div className="text vcenter">
                  <span>
                  Günlük
                  </span>
              </div>
          </Link>
          <Link  to={"/omsg-report/invoice"} className="item">
              <div className="logo vcenter">
                  <img src={require('../../../assets/icons/icon-home-activity.png')} />
              </div>
              <div className="text vcenter">
                  <span>
                  Fatura Dönemi Bazlı
                  </span>
              </div>
          </Link>
          <Link  to={"/omsg-report/error_code"} className="item">
              <div className="logo vcenter">
                <img src={require('../../../assets/icons/icon-home-slash.png')} />
              </div>
              <div className="text vcenter">
                  <span>
                  Hata Kodu Bazlı
                  </span>
              </div>
          </Link>
        </section>
      );
    }
  }

  export default Home;